import {ProjectFeatureFlag} from 'common/report/constants';
import {ContentType, Dashboard} from 'common/report/dashboards/types';
import {CurrentProject} from 'common/report/model-resources/projects';
import {isAllowedSuperadminOverride} from 'common/report/util/saved-entities';

// The rollout percentage for nested dashboards, should be kept in sync with backend equivalent
const NESTED_DASHBOARDS_ROLLOUT_PERCENTAGE = 50;

export const dashboardUtils = {
  canEditDashboard,
};

//TODO rename contentData to contentParams
export interface ContentDetails {
  contentId?: string;
  contentParams?: any;
  contentType: ContentType;
}

function canEditDashboard(dashboard: Pick<Dashboard, 'allow_staff_override' | 'is_superadmin' | 'can_update_basic'>) {
  return dashboard.can_update_basic || isAllowedSuperadminOverride(dashboard);
}

export function isTextCardAlignmentEnabled(project: CurrentProject) {
  return project?.hasFeatureFlag(ProjectFeatureFlag.TextCardAlignment);
}

export function getCardIdFromContent(contentId, contentType: ContentType) {
  return `${contentType}-${contentId}`;
}

export function isNestedDashboardsEnabled(project: CurrentProject) {
  const isInFeatureFlag = project?.hasFeatureFlag(ProjectFeatureFlag.NestedDashboards) || false;

  return isInFeatureFlag || (project && project.id % 100 < NESTED_DASHBOARDS_ROLLOUT_PERCENTAGE);
}

export function isDashboardsAIEnabled(project: CurrentProject) {
  return project?.hasFeatureFlag(ProjectFeatureFlag.DashboardsAI);
}
